import React, { useEffect } from "react";
import BannerSection from "./sections/banner/BannerSection";
import QuotesSection from "./sections/quotes/QuotesSection";
import GameInfoSection from "./sections/gameInfo/GameInfoSection";
import NextGenSection from "./sections/nextGen/NextGenSection";
import BuyNowSection from "./sections/buynow/BuyNowSection";
import MediaSection from "./sections/media/MediaSection";
import routes from "routes";
// import TypographyShowcase from "components/showcases/TypographyShowcase";
// import ButtonShowcase from "components/showcases/ButtonShowcase";
// import GlitchShowcase from "components/showcases/GlitchShowcase";
// import PageSectionShowcase from "components/showcases/PageSectionShowcase";

export default function HomePage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <BannerSection style={{ position: "relative", zIndex: 10 }} />
            <QuotesSection />
            <GameInfoSection id={routes.home.anchors.gameInfo} />
            <NextGenSection id={routes.home.anchors.nextGen} />
            <BuyNowSection
                id={routes.home.anchors.buy}
                style={{ position: "relative", zIndex: 10 }}
            />
            <MediaSection id={routes.home.anchors.media} />
            {/* 
            <TypographyShowcase />
            <PageSectionShowcase />
            <GlitchShowcase />
            <ButtonShowcase />
             */}
        </>
    );
}
